var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterBoiler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57{fill:none;}.cls-2{clip-path:url(#clippath-8);}.cls-3{clip-path:url(#clippath-7);}.cls-4{clip-path:url(#clippath-6);}.cls-5{clip-path:url(#clippath-9);}.cls-6{clip-path:url(#clippath-5);}.cls-7{clip-path:url(#clippath-3);}.cls-8{clip-path:url(#clippath-4);}.cls-9{clip-path:url(#clippath-2);}.cls-10{clip-path:url(#clippath-1);}.cls-11{isolation:isolate;}.cls-12{stroke:#a3cfe2;stroke-linecap:round;stroke-width:2.26px;}.cls-12,.cls-56{stroke-miterlimit:10;}.cls-58{fill:#697b81;}.cls-59{fill:#eee;}.cls-60{fill:#f3c676;}.cls-61{fill:#c0e0e4;}.cls-62{fill:#c3e4f0;}.cls-63{fill:#e0e0e0;}.cls-64{fill:#1f262c;}.cls-65{fill:#41939e;}.cls-66{fill:#434a51;}.cls-67{fill:#1d2529;}.cls-68{fill:#1c2328;}.cls-69{fill:#6d7f86;}.cls-70{fill:#886f42;}.cls-71{fill:#344249;}.cls-72{fill:#836b3f;}.cls-13{clip-path:url(#clippath-13);}.cls-14{clip-path:url(#clippath-14);}.cls-15{clip-path:url(#clippath-12);}.cls-16{clip-path:url(#clippath-11);}.cls-17{clip-path:url(#clippath-18);}.cls-18{clip-path:url(#clippath-19);}.cls-19{clip-path:url(#clippath-17);}.cls-20{clip-path:url(#clippath-16);}.cls-21{clip-path:url(#clippath-10);}.cls-22{clip-path:url(#clippath-15);}.cls-23{clip-path:url(#clippath-25);}.cls-24{clip-path:url(#clippath-22);}.cls-25{clip-path:url(#clippath-23);}.cls-26{clip-path:url(#clippath-24);}.cls-27{clip-path:url(#clippath-21);}.cls-28{clip-path:url(#clippath-20);}.cls-29{clip-path:url(#clippath-45);}.cls-30{clip-path:url(#clippath-40);}.cls-31{clip-path:url(#clippath-42);}.cls-32{clip-path:url(#clippath-41);}.cls-33{clip-path:url(#clippath-44);}.cls-34{clip-path:url(#clippath-43);}.cls-35{clip-path:url(#clippath-46);}.cls-36{clip-path:url(#clippath-47);}.cls-37{clip-path:url(#clippath-49);}.cls-38{clip-path:url(#clippath-48);}.cls-39{clip-path:url(#clippath-34);}.cls-40{clip-path:url(#clippath-30);}.cls-41{clip-path:url(#clippath-32);}.cls-42{clip-path:url(#clippath-33);}.cls-43{clip-path:url(#clippath-35);}.cls-44{clip-path:url(#clippath-36);}.cls-45{clip-path:url(#clippath-39);}.cls-46{clip-path:url(#clippath-37);}.cls-47{clip-path:url(#clippath-29);}.cls-48{clip-path:url(#clippath-26);}.cls-49{clip-path:url(#clippath-28);}.cls-50{clip-path:url(#clippath-27);}.cls-51{clip-path:url(#clippath-38);}.cls-52{clip-path:url(#clippath-31);}.cls-53{clip-path:url(#clippath-52);}.cls-54{clip-path:url(#clippath-51);}.cls-55{clip-path:url(#clippath-50);}.cls-56{stroke:#000;stroke-width:.23px;}.cls-57{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.2,59.05c.4-.47.76-1,1.08-1.55.06.04.12.07.19.11-.31.55-.68,1.07-1.08,1.55-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.16,56.04s.02,0,.02.01c-.19.53-.43,1.06-.72,1.56-.06-.04-.12-.07-.19-.11.28-.5.53-1.03.72-1.56.05.03.11.06.16.1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.2,59.05c.06.04.12.07.19.11-.15.18-.31.36-.48.52-.06-.04-.12-.07-.19-.11.16-.17.32-.34.48-.52Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.2,60.77c.54-.31,1.05-.72,1.53-1.2.06.04.12.07.19.11-.47.48-.99.89-1.53,1.2-.06-.03-.13-.08-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.99,55.94c.31-.87.49-1.75.49-2.58.06.04.12.07.19.11,0,.83-.17,1.71-.49,2.58-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.19,59.89c1.95-1.13,3.53-3.85,3.52-6.09.06.04.12.07.19.11,0,2.24-1.57,4.96-3.52,6.09-.06-.03-.13-.08-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.44,61.13c.24-.09.5-.21.75-.36l.19.11c-.26.15-.51.27-.75.36-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.18,61.22c.09-.03.17-.06.26-.09.06.04.12.07.19.11-.09.03-.18.06-.26.09-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.19,61.36c.31,0,.64-.04.99-.14.06.04.12.07.19.11-.35.1-.68.15-.99.14-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.28,61.41s.07.04.1.06c0,0,0,0,0,0-.15-.08-.16-.09-.19-.11,0,0,0,0,0,0,.03.02.06.03.09.05Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.98,51.35c.06.04.12.07.19.11.32.5.5,1.18.5,2.01-.06-.04-.12-.07-.19-.11,0-.83-.18-1.51-.5-2.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.69,56.78c.14.08.32.07.53-.05l.19.11c-.21.12-.4.13-.53.05-.06-.03-.13-.08-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.98,51.35c-.2-.32-.46-.57-.75-.74l.19.11c.3.17.55.42.75.74-.06-.04-.13-.06-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.71,53.81c0-1.11-.4-1.9-1.03-2.27l.19.11c.63.37,1.03,1.15,1.03,2.27-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.14,61.07c.31.18.66.28,1.05.29q.06.04.19.11c-.39-.01-.74-.11-1.05-.29-.06-.03-.13-.08-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.68,60.14c.64.37,1.53.32,2.51-.25l.19.11c-.98.57-1.87.62-2.51.25-.06-.03-.13-.08-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.39,60.34c.06.04.12.07.19.11.2.32.45.56.75.74l-.19-.11c-.3-.17-.55-.42-.75-.74Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.17,50.32c.39.01.75.11,1.06.29l.19.11c-.31-.18-.67-.28-1.06-.29-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.39,60.34s-.06-.09-.08-.14c.06.04.12.07.19.11.03.05.05.09.08.14-.06-.04-.13-.06-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.98,55.43c0-.43-.28-2.45-.64-2.66l.19.11c.36.21.64,2.23.64,2.66,0,.47-.34,1.06-.75,1.3l-.19-.11c.41-.24.75-.82.75-1.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.88,56.89l-.19-.11c-.14-.08-.22-.25-.22-.48,0-.47.32-3.28.74-3.52l.19.11c-.42.24-.74,3.05-.74,3.52,0,.24.08.4.22.48Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.34,52.77l.19.11s-.08-.02-.12,0l-.19-.11s.08-.02.12,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.17,50.32c.07.02.12.07.19.11-.31,0-.64.04-.99.14-.06-.04-.12-.07-.19-.11.35-.1.68-.15.99-.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.39,60.2c.06.04.12.07.19.11.24.8.67,1.39,1.26,1.73l-.19-.11c-.58-.34-1.02-.92-1.26-1.73Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.92,50.55c.09-.03.18-.06.26-.09.06.04.12.07.19.11-.09.03-.17.06-.26.09-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.68,51.54l.19.11c-.64-.37-1.53-.32-2.51.25l-.19-.11c.98-.57,1.87-.62,2.51-.25Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.17,50.91c.26-.15.51-.27.75-.36.06.04.12.07.19.11-.24.09-.5.21-.75.36-.06-.03-.13-.08-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.06,51.72c.35-.31.73-.59,1.11-.81l.19.11c-.38.22-.76.49-1.11.81-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.87,60.25l-.19-.11c-.63-.37-1.02-1.15-1.03-2.26,0-2.24,1.57-4.97,3.52-6.09l.19.11c-1.95,1.12-3.53,3.85-3.52,6.09,0,1.11.4,1.89,1.03,2.26Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.64,52.11c.13-.14.27-.27.41-.39.06.04.12.07.19.11-.14.12-.28.26-.41.39-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.37,55.74c.06.04.12.07.19.11-.31.87-.49,1.75-.49,2.59,0,.76.15,1.39.42,1.87-.06-.04-.12-.07-.19-.11-.27-.49-.42-1.12-.42-1.87,0-.83.17-1.72.49-2.59Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.17,52.63c.15-.18.31-.36.47-.52.06.04.12.07.19.11-.16.17-.32.34-.47.52-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.37,55.74c.19-.53.44-1.06.72-1.57.06.04.12.07.19.11-.29.5-.53,1.03-.72,1.57-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.17,52.63c.06.04.12.07.19.11-.4.47-.76,1-1.07,1.55-.06-.04-.12-.07-.19-.11.31-.55.67-1.07,1.07-1.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.77,51.13c.06.04.12.07.19.11-.25.23-.5.48-.73.74-.06-.04-.12-.07-.19-.11.23-.26.48-.51.73-.74Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.38,57.03c.23-1.08.67-2.18,1.26-3.2.06.04.12.07.19.11-.59,1.02-1.03,2.12-1.26,3.2-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.8,49.48c.73-.13,1.39-.03,1.92.28l.19.11c-.53-.31-1.19-.41-1.92-.28-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.8,49.48s0,0,0,0c.06.04.12.07.19.11,0,0,0,0,0,0-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.56,49.53c.08-.02.16-.04.24-.05.06.04.12.07.19.11-.08.01-.16.03-.24.05-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.39,60.2s-.03-.09-.04-.14c.06.04.12.07.19.11.01.05.03.1.04.14,0,0,0,0,0,0t-.1-.06s-.06-.02-.08-.05Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.56,49.53s.02.01.03.02c.05.03.1.06.15.09-.05.01-.1.02-.14.04-.06-.04-.12-.07-.19-.11.05-.01.1-.03.14-.04Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.35,60.06c-.02-.08-.04-.15-.05-.23.06.04.12.07.19.11.02.08.03.16.05.23-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.3,59.83c-.03-.13-.05-.27-.06-.41.06.04.12.07.19.11.02.14.04.28.06.41-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.17,50.11c.43-.25.85-.43,1.25-.54.06.04.12.07.19.11-.4.11-.82.29-1.25.54-.06-.03-.13-.08-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.19,58.73c0-.4.03-.81.1-1.22.06.04.12.07.19.11-.07.41-.1.82-.1,1.22,0,.24.01.47.04.69-.06-.04-.12-.07-.19-.11-.03-.22-.04-.45-.04-.69Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.15,50.81c.33-.27.67-.51,1.02-.71l.19.11c-.35.2-.69.44-1.02.71-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.29,57.51c.02-.1.03-.19.05-.29.06.04.12.07.19.11-.02.1-.04.19-.05.29-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.38,57.03c.06.04.12.07.19.11-.01.06-.03.13-.04.19-.06-.04-.12-.07-.19-.11.01-.06.02-.13.04-.19Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.77,51.13c.12-.11.25-.22.37-.32.06.04.12.07.19.11-.13.1-.25.21-.37.32-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.64,53.83s0,0,0,0c.06.04.12.07.19.11,0,0,0,0,0,0-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.64,53.83s0,0,0,0c.06.04.12.07.19.11,0,0,0,0,0,0-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.64,53.82s0,0,0,0c.06.04.12.07.19.11,0,0,0,0,0,0-.06-.04-.12-.07-.19-.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.64,53.82c.4-.7.88-1.36,1.4-1.95.06.04.12.07.19.11-.52.59-1,1.25-1.4,1.95-.06-.04-.12-.07-.19-.11Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "water_boiler"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m72.86,85.87c0,.43-.25.83-.64,1.01l-24.02,12.01c-3,1.5-6.55,1.43-9.49-.18l-10.79-5.91c-.48-.26-.7-.63-.7-1.17h0c.23-1.03.91-1.92,1.88-2.39l23.78-11.56c2.63-1.28,5.71-1.21,8.27.19l10.29,5.61c.87.48,1.42,1.39,1.42,2.39Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 44.36,
    y1: 80.38,
    x2: 44.36,
    y2: 96.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 53.85,
    y1: 72.38,
    x2: 53.85,
    y2: 88.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m72.86,9.07c0,.43-.25.83-.64,1.01l-24.02,12.01c-3,1.5-6.55,1.43-9.49-.18l-10.79-5.91c-.48-.26-.7-.63-.7-1.17h0c.23-1.03.91-1.92,1.88-2.39L52.88.88c2.63-1.28,5.71-1.21,8.27.19l10.29,5.61c.87.48,1.42,1.39,1.42,2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m72.86,9.07v4.6c0,1.09-.62,2.08-1.6,2.55l-23.79,11.55c-2.61,1.27-5.67,1.26-8.27-.04l-9.86-4.91c-1.35-.67-2.21-2.06-2.21-3.57v-3.68c0-.25.03-.5.08-.75,0,.54.22.91.7,1.17l10.79,5.91c2.94,1.61,6.49,1.68,9.49.18l24.02-12.01c.39-.19.64-.58.64-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m71.27,16.22l-23.79,11.55c-2.61,1.27-5.67,1.26-8.27-.04l-9.86-4.91c-1.35-.67-2.21-2.06-2.21-3.57v46.05c0,1.65.97,3.16,2.49,3.83l11.01,4.89c1.97.88,4.23.85,6.18-.07l24.67-11.69c.84-.4,1.37-1.24,1.37-2.17V13.67c0,1.09-.62,2.08-1.6,2.55Zm-7.27,21.42l-8.47,4.17v-3.93l8.47-4.06v3.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "64 37.64 55.53 41.8 55.53 37.88 64 33.81 64 37.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m72.86,60.09v6.37c0,.29-.16.56-.42.7l-23.47,11.96c-3.19,1.63-6.96,1.69-10.2.17l-8.41-3.93c-1.96-.92-3.21-2.88-3.21-5.04v-5.01c0,1.65.97,3.16,2.49,3.83l11.01,4.89c1.97.88,4.23.85,6.18-.07l24.67-11.69c.84-.4,1.37-1.24,1.37-2.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64 33.81 64 37.64 55.53 41.8 55.53 37.88 64 33.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m52.84,62.52c-.32.86-1.1,1.37-1.75,1.13l-.14-.06c-.34-.19-.55-.58-.59-1.03-.02-.28.01-.59.13-.9.14-.38.37-.69.64-.9.34-.26.74-.36,1.1-.23.65.24.91,1.13.6,1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m52.24,60.52c-.36-.13-.76-.03-1.1.23-.27.21-.5.52-.64.9-.11.31-.15.62-.13.9.04.46.25.84.59,1.03l-1.69-.8c-.65-.24-.91-1.13-.59-1.99.32-.86,1.1-1.37,1.74-1.13l.14.06,1.69.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m70.82,53.59c-.32.86-1.1,1.37-1.75,1.13l-.14-.06c-.34-.19-.55-.58-.59-1.03-.02-.28.01-.59.13-.9.14-.38.37-.69.64-.9.34-.26.74-.36,1.1-.23.65.24.91,1.13.6,1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m70.23,51.6c-.36-.13-.76-.03-1.1.23-.27.21-.5.52-.64.9-.11.31-.15.62-.13.9.04.46.25.84.59,1.03l-1.69-.8c-.65-.24-.91-1.13-.59-1.99.32-.86,1.1-1.37,1.74-1.13l.14.06,1.69.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m60.32,60.23l-.19-.11c1.92-1.6,3.35-4.4,3.35-6.75,0-1.35-.48-2.31-1.25-2.76l.19.11c.77.45,1.25,1.4,1.25,2.76,0,2.35-1.43,5.15-3.35,6.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m60.32,60.23l-.19-.11c1.92-1.6,3.35-4.4,3.35-6.75,0-1.35-.48-2.31-1.25-2.76l.19.11c.77.45,1.25,1.4,1.25,2.76,0,2.35-1.43,5.15-3.35,6.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m60.32,60.23l-.19-.11c1.92-1.6,3.35-4.4,3.35-6.75,0-1.35-.48-2.31-1.25-2.76l.19.11c.77.45,1.25,1.4,1.25,2.76,0,2.35-1.43,5.15-3.35,6.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m59.38,60.88l-.19-.11c.32-.19.63-.41.93-.66l.19.11c-.3.25-.61.47-.93.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m60.32,60.23l-.19-.11c1.92-1.6,3.35-4.4,3.35-6.75,0-1.35-.48-2.31-1.25-2.76l.19.11c.77.45,1.25,1.4,1.25,2.76,0,2.35-1.43,5.15-3.35,6.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m60.32,60.23l-.19-.11c1.92-1.6,3.35-4.4,3.35-6.75,0-1.35-.48-2.31-1.25-2.76l.19.11c.77.45,1.25,1.4,1.25,2.76,0,2.35-1.43,5.15-3.35,6.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m59.38,60l-.19-.11c.26-.15.52-.33.77-.54l.19.11c-.25.21-.51.39-.77.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m60.15,59.46l-.19-.11c1.58-1.32,2.75-3.61,2.75-5.55,0-1.11-.4-1.9-1.03-2.27l.19.11c.63.37,1.03,1.15,1.03,2.27,0,1.93-1.17,4.23-2.75,5.55"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m56.32,61.18l-.19-.11c.78.45,1.86.39,3.06-.3l.19.11c-1.2.69-2.28.75-3.06.3"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m56.32,61.18l-.19-.11c.78.45,1.86.39,3.06-.3l.19.11c-1.2.69-2.28.75-3.06.3"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m56.32,61.18l-.19-.11c.78.45,1.86.39,3.06-.3l.19.11c-1.2.69-2.28.75-3.06.3"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m56.32,61.18l-.19-.11c.78.45,1.86.39,3.06-.3l.19.11c-1.2.69-2.28.75-3.06.3"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m60.32,60.23l-.19-.11c1.92-1.6,3.35-4.4,3.35-6.75,0-1.35-.48-2.31-1.25-2.76l.19.11c.77.45,1.25,1.4,1.25,2.76,0,2.35-1.43,5.15-3.35,6.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m58.88,56.89l-.19-.11c.14.08.32.07.53-.05l.19.11c-.21.12-.4.13-.53.05"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m60.32,60.23l-.19-.11c1.92-1.6,3.35-4.4,3.35-6.75,0-1.35-.48-2.31-1.25-2.76l.19.11c.77.45,1.25,1.4,1.25,2.76,0,2.35-1.43,5.15-3.35,6.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m60.15,59.46l-.19-.11c1.58-1.32,2.75-3.61,2.75-5.55,0-1.11-.4-1.9-1.03-2.27l.19.11c.63.37,1.03,1.15,1.03,2.27,0,1.93-1.17,4.23-2.75,5.55"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m56.32,61.18l-.19-.11c.78.45,1.86.39,3.06-.3l.19.11c-1.2.69-2.28.75-3.06.3"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m56.87,60.25l-.19-.11c.64.37,1.53.32,2.51-.25l.19.11c-.98.57-1.87.62-2.51.25"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m56.32,61.18l-.19-.11c-.77-.45-1.25-1.4-1.25-2.75,0-2.36,1.43-5.16,3.35-6.76l.19.11c-1.92,1.6-3.36,4.4-3.35,6.76,0,1.35.48,2.3,1.25,2.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m59.35,51.02l-.19-.11c1.19-.69,2.28-.75,3.06-.3l.19.11c-.78-.45-1.86-.39-3.06.3"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m56.32,61.18l-.19-.11c-.77-.45-1.25-1.4-1.25-2.75,0-2.36,1.43-5.16,3.35-6.76l.19.11c-1.92,1.6-3.36,4.4-3.35,6.76,0,1.35.48,2.3,1.25,2.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m59.42,56.83l-.19-.11c.06-.03.11-.07.16-.11l.19.11c-.05.04-.11.08-.16.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m59.58,56.72l-.19-.11c.34-.28.59-.77.59-1.18s-.28-2.45-.64-2.66l.19.11c.36.21.64,2.23.64,2.66s-.25.9-.59,1.18"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m58.88,56.89l-.19-.11c-.14-.08-.22-.25-.22-.48,0-.46.31-3.16.72-3.5l.19.11c-.41.34-.72,3.04-.72,3.5,0,.24.08.4.22.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m59.38,52.9l-.19-.11s.02-.01.03-.02l.19.11s-.02.01-.03.02"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m59.4,52.88l-.19-.11s.08-.02.12,0l.19.11s-.08-.02-.12,0"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m59.35,51.02l-.19-.11c1.19-.69,2.28-.75,3.06-.3l.19.11c-.78-.45-1.86-.39-3.06.3"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m55.84,62.03l-.19-.11c-.9-.52-1.45-1.63-1.45-3.2,0-2.74,1.66-6,3.89-7.86l.19.11c-2.23,1.86-3.9,5.12-3.89,7.86,0,1.57.56,2.68,1.45,3.2"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m59.35,51.02l-.19-.11c1.19-.69,2.28-.75,3.06-.3l.19.11c-.78-.45-1.86-.39-3.06.3"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m59.36,51.9l-.19-.11c.98-.57,1.87-.62,2.51-.25l.19.11c-.64-.37-1.53-.32-2.51.25"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m59.35,51.02l-.19-.11c1.19-.69,2.28-.75,3.06-.3l.19.11c-.78-.45-1.86-.39-3.06.3"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m56.32,61.18l-.19-.11c-.77-.45-1.25-1.4-1.25-2.75,0-2.36,1.43-5.16,3.35-6.76l.19.11c-1.92,1.6-3.36,4.4-3.35,6.76,0,1.35.48,2.3,1.25,2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m58.42,51.67l-.19-.11c.3-.25.61-.47.93-.66l.19.11c-.32.19-.63.41-.93.66"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m56.87,60.25l-.19-.11c-.63-.37-1.02-1.15-1.03-2.26,0-1.94,1.18-4.24,2.75-5.56l.19.11c-1.58,1.31-2.76,3.62-2.75,5.56,0,1.11.4,1.89,1.03,2.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m58.59,52.44l-.19-.11c.25-.21.5-.39.77-.54l.19.11c-.26.15-.52.33-.77.54"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m56.32,61.18l-.19-.11c-.77-.45-1.25-1.4-1.25-2.75,0-2.36,1.43-5.16,3.35-6.76l.19.11c-1.92,1.6-3.36,4.4-3.35,6.76,0,1.35.48,2.3,1.25,2.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m56.32,61.18l-.19-.11c-.77-.45-1.25-1.4-1.25-2.75,0-2.36,1.43-5.16,3.35-6.76l.19.11c-1.92,1.6-3.36,4.4-3.35,6.76,0,1.35.48,2.3,1.25,2.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m56.32,61.18l-.19-.11c-.77-.45-1.25-1.4-1.25-2.75,0-2.36,1.43-5.16,3.35-6.76l.19.11c-1.92,1.6-3.36,4.4-3.35,6.76,0,1.35.48,2.3,1.25,2.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m56.32,61.18l-.19-.11c-.77-.45-1.25-1.4-1.25-2.75,0-2.36,1.43-5.16,3.35-6.76l.19.11c-1.92,1.6-3.36,4.4-3.35,6.76,0,1.35.48,2.3,1.25,2.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m56.32,61.18l-.19-.11c-.77-.45-1.25-1.4-1.25-2.75,0-2.36,1.43-5.16,3.35-6.76l.19.11c-1.92,1.6-3.36,4.4-3.35,6.76,0,1.35.48,2.3,1.25,2.75"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m55.84,62.03l-.19-.11c-.9-.52-1.45-1.63-1.45-3.2,0-2.74,1.66-6,3.89-7.86l.19.11c-2.23,1.86-3.9,5.12-3.89,7.86,0,1.57.56,2.68,1.45,3.2"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m55.84,62.03l-.19-.11c-.9-.52-1.45-1.63-1.45-3.2,0-2.74,1.66-6,3.89-7.86l.19.11c-2.23,1.86-3.9,5.12-3.89,7.86,0,1.57.56,2.68,1.45,3.2"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m59.35,50.21c2.76-1.59,5-.31,5.01,2.86s-2.22,7.02-4.98,8.61-4.99.32-5-2.85c0-3.17,2.21-7.03,4.97-8.62Zm.03,10.67c2.37-1.37,4.29-4.69,4.28-7.41,0-2.73-1.94-3.83-4.31-2.46s-4.29,4.69-4.28,7.42c0,2.72,1.94,3.82,4.31,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m59.36,51.9c-1.95,1.12-3.53,3.85-3.52,6.09,0,2.24,1.6,3.13,3.54,2.01,1.95-1.13,3.53-3.85,3.52-6.09,0-2.24-1.59-3.15-3.54-2.02Zm.06,4.94c-.42.24-.75.05-.75-.43,0-.47.32-3.28.74-3.52.41-.24.76,2.18.76,2.66s-.34,1.06-.75,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m59.35,51.02c2.37-1.37,4.3-.27,4.31,2.46,0,2.72-1.91,6.04-4.28,7.41-2.37,1.37-4.3.27-4.31-2.45,0-2.73,1.91-6.05,4.28-7.42Zm.03,8.98c1.95-1.13,3.53-3.85,3.52-6.09,0-2.24-1.59-3.15-3.54-2.02s-3.53,3.85-3.52,6.09,1.6,3.13,3.54,2.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m59.4,52.88c.41-.24.76,2.18.76,2.66s-.34,1.06-.75,1.3-.75.05-.75-.43.32-3.28.74-3.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m59.35,50.21l-.19-.11c1.39-.8,2.64-.87,3.55-.35l.19.11c-.91-.53-2.17-.45-3.55.35"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m59.35,50.21l-.19-.11c1.39-.8,2.64-.87,3.55-.35l.19.11c-.91-.53-2.17-.45-3.55.35"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m59.35,50.21l-.19-.11c1.39-.8,2.64-.87,3.55-.35l.19.11c-.91-.53-2.17-.45-3.55.35"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m55.84,62.03l-.19-.11c-.9-.52-1.45-1.63-1.45-3.2,0-2.74,1.66-6,3.89-7.86l.19.11c-2.23,1.86-3.9,5.12-3.89,7.86,0,1.57.56,2.68,1.45,3.2"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m59.35,50.21l-.19-.11c1.39-.8,2.64-.87,3.55-.35l.19.11c-.91-.53-2.17-.45-3.55.35"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m55.84,62.03l-.19-.11c-.9-.52-1.45-1.63-1.45-3.2,0-2.74,1.66-6,3.89-7.86l.19.11c-2.23,1.86-3.9,5.12-3.89,7.86,0,1.57.56,2.68,1.45,3.2"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m55.84,62.03l-.19-.11c-.9-.52-1.45-1.63-1.45-3.2,0-2.74,1.66-6,3.89-7.86l.19.11c-2.23,1.86-3.9,5.12-3.89,7.86,0,1.57.56,2.68,1.45,3.2"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m59.35,50.21l-.19-.11c1.39-.8,2.64-.87,3.55-.35l.19.11c-.91-.53-2.17-.45-3.55.35"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m55.84,62.03l-.19-.11c-.9-.52-1.45-1.63-1.45-3.2,0-2.74,1.66-6,3.89-7.86l.19.11c-2.23,1.86-3.9,5.12-3.89,7.86,0,1.57.56,2.68,1.45,3.2"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m58.27,50.98l-.19-.11c.35-.29.71-.55,1.08-.76l.19.11c-.37.21-.73.47-1.08.76"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m55.84,62.03l-.19-.11c-.9-.52-1.45-1.63-1.45-3.2,0-2.74,1.66-6,3.89-7.86l.19.11c-2.23,1.86-3.9,5.12-3.89,7.86,0,1.57.56,2.68,1.45,3.2"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m55.84,62.03l-.19-.11c-.9-.52-1.45-1.63-1.45-3.2,0-2.74,1.66-6,3.89-7.86l.19.11c-2.23,1.86-3.9,5.12-3.89,7.86,0,1.57.56,2.68,1.45,3.2"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m55.84,62.03l-.19-.11c-.9-.52-1.45-1.63-1.45-3.2,0-2.74,1.66-6,3.89-7.86l.19.11c-2.23,1.86-3.9,5.12-3.89,7.86,0,1.57.56,2.68,1.45,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m58.27,50.98l-.19-.11c.35-.29.71-.55,1.08-.76l.19.11c-.37.21-.73.47-1.08.76"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m55.84,62.03l-.19-.11c-.9-.52-1.45-1.63-1.45-3.2,0-2.74,1.66-6,3.89-7.86l.19.11c-2.23,1.86-3.9,5.12-3.89,7.86,0,1.57.56,2.68,1.45,3.2"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m55.84,62.03l-.19-.11c-.9-.52-1.45-1.63-1.45-3.2,0-2.74,1.66-6,3.89-7.86l.19.11c-2.23,1.86-3.9,5.12-3.89,7.86,0,1.57.56,2.68,1.45,3.2"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m55.84,62.03l-.19-.11c-.9-.52-1.45-1.63-1.45-3.2,0-2.74,1.66-6,3.89-7.86l.19.11c-2.23,1.86-3.9,5.12-3.89,7.86,0,1.57.56,2.68,1.45,3.2"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m55.84,62.03l-.19-.11c-.9-.52-1.45-1.63-1.45-3.2,0-2.74,1.66-6,3.89-7.86l.19.11c-2.23,1.86-3.9,5.12-3.89,7.86,0,1.57.56,2.68,1.45,3.2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterBoiler);
export default __webpack_public_path__ + "static/media/water-boiler.a6a42cb2c7d48cbc4ddd56f286792d4e.svg";
export { ForwardRef as ReactComponent };